import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AlgChannelService} from "./channel.service";
import { Core2Config } from '../../../shared';

@Injectable({providedIn: "root"})
export class LineService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "line/send";
    this.httpClient = httpClient;
  }

  public setUserId(userId: string, authToken:String, apiVisa: any) {
    let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "line/set_id";
    let body = {
      "user_id": userId,
      "auth_token": authToken
    }
    return this.httpClient.post(apiUrl,body, this.getHttpHeader(apiVisa));

  }
}
